
import { ArticleData, CATEGORY } from './types';
import { endEndDesign } from "./e2edesign";
import { userBehaviourSequence } from "./user-behaviour-sequence";
import { evolutionCandidateGeneration } from "./evolution";

export const mlFundamentalsArticles: ArticleData[] = [
  endEndDesign,
  userBehaviourSequence, // Added the new article
  evolutionCandidateGeneration,
  {
    id: 1,
    slug: 'faang-ml-interviews',
    title: 'How to Crack ML Interviews at FAANG',
    description: 'A comprehensive guide to preparing for ML interviews at top tech companies.',
    author: 'Bharathi Priyaa',
    publishDate: 'December 15, 2022',
    category: CATEGORY.ML_FUNDAMENTALS,
    readTime: '12 min read',
    readCount: 1256,
    likeCount: 341,
    contentPath: 'faang-ml-interviews.md',
    previousArticleSlug: undefined
  },
  {
    id: 2,
    slug: 'faang-ml-interviews-part2',
    title: 'Level Up Your FAANG ML Interview – Tips for IC2 to IC6',
    description: 'ML design expectations for different career levels.',
    author: 'Bharathi Priyaa',
    publishDate: 'June 13, 2023',
    category: CATEGORY.ML_FUNDAMENTALS,
    readTime: '15 min read',
    readCount: 10,
    likeCount: 2,
    contentPath: 'article-content/part2.md',
    previousArticleSlug: 'faang-ml-interviews',
    isPremium: true
  },
  {
    id: 6,
    slug: 'user-embeddings',
    title: 'How to Build and Serve User Embeddings',
    description: 'Learn techniques for creating and deploying effective user embeddings for recommendation systems.',
    author: 'Bharathi Priyaa',
    publishDate: 'May 1, 2025',
    category: CATEGORY.ML_FUNDAMENTALS,
    readTime: '20 min read',
    readCount: 0,
    likeCount: 0,
    isPremium: true,
    comingSoon: true
  },
  {
    id: 7,
    slug: 'ads-calibration',
    title: 'All about Ads calibration',
    description: 'Understand techniques for calibrating ads models to improve fairness and accuracy.',
    author: 'HelloML',
    publishDate: 'May 12, 2025',
    category: CATEGORY.ML_FUNDAMENTALS,
    readTime: '15 min read',
    readCount: 0,
    likeCount: 0,
    isPremium: true,
    contentType: 'html'
  },
  {
    id: 14,
    slug: 'biases',
    title: 'Biases in recommender systems',
    description: 'Overview of common biases that affect recommendation algorithms and ways to mitigate them.',
    author: 'HelloML',
    publishDate: 'June 20, 2025',
    category: CATEGORY.ML_FUNDAMENTALS,
    readTime: '10 min read',
    readCount: 0,
    likeCount: 0,
    isPremium: true,
    contentType: 'html'
  }
];
